import React from 'react'
import { colors } from '@ui/colors'
import InputAction from './InputAction'
import { useToast } from '@ui/toasts/useToastManager'

export type IndicatorProps = {
  id?: string
  message?: string
}

export const SuccessIndicator = ({ id, message }: IndicatorProps) => {
  const toast = useToast()

  return (
    <InputAction
      disabled={!message}
      onPress={() =>
        toast({
          id,
          text: message,
          variant: 'success',
        })
      }
      icon="circle-check"
      color={colors.green[600]}
    />
  )
}

export const ErrorIndicator = ({ id, message }: IndicatorProps) => {
  const toast = useToast()

  return (
    <InputAction
      disabled={!message}
      onPress={() =>
        toast({
          id,
          text: message,
          variant: 'error',
        })
      }
      icon="exclamation-circle"
      color={colors.red[600]}
    />
  )
}
